//API danh mục quy định lương, thuế TNCN, bảo hiểm
import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';
class PAOptionAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'PAOptions';

  /**
   * Lấy dữ liệu danh mục Quy định lương, thuế, bảo hiểm
   * @returns
   */
  async getDataPAOption() {
    let request = {
      url: `${this.getAPIUrl()}/getData`,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Cập nhật dữ liệu danh mục Quy định lương, thuế, bảo hiểm
   * @returns
   */
  async updateDataPAOption(data) {
    let request = {
      url: `${this.getAPIUrl()}/updateData`,
      data: { ...data },
    };

    return httpClient.putAsync(request);
  }
}

export default new PAOptionAPI();
